import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lmwBaseRoutes } from '../../routing/route-locales/lmw-base-routes';
import { CaseStudyCms } from '../../interfaces/case-study-cms.interface';
import { environment } from 'apps/learn-my-way/src/environments/environment';
@Component({
  selector: 'lmw-base-case-study',
  templateUrl: './case-study.component.html',
  styles: [
  ]
})
export class CaseStudyComponent implements OnInit {

  public browseAllSubjectsLink: string = lmwBaseRoutes.browseSubjectsStatePath;
  public reportAnIssueLink: string = lmwBaseRoutes.reportAnIssueStatePath;
  public caseStudyCms: CaseStudyCms;
  public language: string = environment.language;
  public mobileBackButtonText = lmwBaseRoutes.homeLinkText;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.caseStudyCms = this.route.snapshot.data.cmsData;
  }

}
